import * as zoid from "@krakenjs/zoid/dist/zoid.frameworks.js";

export const ModelPreview = zoid.create({
  tag: "model-preview",
  url: `${SERVER_URL}/model-preview`,
  dimensions: {
    width: "100%",
    height: "100%",
  },
});
